var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('img',{staticClass:"client-logo",class:{ 'with-corporation-logo': _vm.withCorporationLogo, },attrs:{"src":_vm.logouri}}),(_vm.corporationLogouri)?_c('img',{staticClass:"corporation-logo",attrs:{"src":_vm.corporationLogouri}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }